export interface NominatimResult {
    lat: string;
    lon: string;
    display_name: string;
}

export interface AddressSuggestion {
    displayName: string;
    primaryName: string;
    secondaryName: string;
    lat: number;
    lon: number;
}

const _nominatimHeaders = {
    'Accept-Language': 'sv',
    'User-Agent': 'sammandrag.se'
};

export async function geocodeAddress(address: string): Promise<{ lat: number; lon: number } | null> {
    if (!address || address.trim().length < 3) return null;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10_000);
    try {
        const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(address)}&format=json&limit=1`;
        const response = await fetch(url, { headers: _nominatimHeaders, signal: controller.signal });
        if (!response.ok) return null;
        const results: NominatimResult[] = await response.json();
        if (!results || results.length === 0) return null;
        return { lat: parseFloat(results[0].lat), lon: parseFloat(results[0].lon) };
    } catch {
        return null;
    } finally {
        clearTimeout(timeout);
    }
}

export async function searchAddresses(query: string): Promise<AddressSuggestion[]> {
    if (!query || query.trim().length < 2) return [];
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10_000);
    try {
        const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=6`;
        const response = await fetch(url, { headers: _nominatimHeaders, signal: controller.signal });
        if (!response.ok) return [];
        const results: NominatimResult[] = await response.json();
        return results.map(r => {
            const parts = r.display_name.split(',');
            const primaryName = parts[0].trim();
            const secondaryName = parts.slice(1).join(',').trim();
            return {
                displayName: r.display_name,
                primaryName,
                secondaryName,
                lat: parseFloat(r.lat),
                lon: parseFloat(r.lon),
            };
        });
    } catch {
        return [];
    } finally {
        clearTimeout(timeout);
    }
}
